import React, { useEffect, useState } from 'react';
import { format, parse } from 'date-fns';

import ProductModal from '../ProductModal/ProductModal';
import Header from '../Header/Header';
import CalendarFilterIcon from '../../icons/CalendarFilterIcon';
import ContentApp from '../../ContentApp';
import Calendar from '../Calendar/Calendar';
import InputFormBorder from './InputFormBorder';
import './input-form-border.css';

const DatePickerBorder = ({ placeholder, value, onChange, error, minDate }) => {
  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');

  useEffect(() => {
    if (value) {
      setSelectedDate(format(parse(value, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy'));
    } else {
      setSelectedDate('');
    }
  }, [value]);

  const handleDateChange = (date) => {
    if (!(date instanceof Date) || isNaN(date)) {
      setCalendarVisible(false);
      return;
    }

    const newFormatted = format(date, 'yyyy-MM-dd');

    if (newFormatted === value) {
      setCalendarVisible(false);
      return;
    }
    setSelectedDate(format(date, 'dd/MM/yyyy'));
    onChange(newFormatted);
    setCalendarVisible(false);
  };

  return (
    <>
      <div onClick={() => setCalendarVisible(true)}>
        <InputFormBorder
          value={selectedDate}
          placeholder={placeholder}
          error={error}
          iconImg={<CalendarFilterIcon size={24} />}
          disableFocus
          readOnly
          inputMode="none"
        />
      </div>

      <ProductModal
        open={calendarVisible}
        fullScreen
        animationClass='fade-up-horizontal'
        hasBackground
        showCloseButton={false}
      >
        <Header onClick={() => setCalendarVisible(false)} showBack />
        <ContentApp>
          <div className='my-calendar-container datepicker-border-calendar'>
            <Calendar
              onSelectDate={handleDateChange}
              selectedDate={value}
              minDate={minDate}
              className='calendar-event'
            />
          </div>
        </ContentApp>
      </ProductModal>
    </>
  );
};

export default DatePickerBorder;
